import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {ReviewerReviewService} from '../reviewer-review.service';


@Injectable()
export class UserReviewsResolver implements Resolve<any> {
	constructor(
		private reviewerReviewService: ReviewerReviewService
	) {}


	params: any = {};


	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
		console.log('UserReviewsResolver called    #1');

		this.params = JSON.parse(JSON.stringify(route.params));

		let thePromise = new Promise((resolve, reject) => {
			this.reviewerReviewService.getUserReviews()
				.then((reviews: any) => {

					console.log('UserReviewsResolver called    #2');

					let userReviewsInfo = {
						reviews: reviews,
						params: this.params
					};
					resolve(userReviewsInfo);
				})
				.catch((err) => {
					return reject(err);
				});
		});

		return Observable.fromPromise(thePromise);
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/user-reviews.resolver.ts